<template>
  <div v-if="data" class="linked-model-wrapper">
    <p class="linked-model__title body-m-regular">
      {{ data?.name }}
      <span v-if="selectedValue"
        >:
        <span class="linked-model__value body-m-regular">{{
          selectedValue
        }}</span>
      </span>
    </p>
    <component
      :is="isLessLg ? HorizontalScroll : 'div'"
      class="linked-model-items__wrapper"
    >
      <nuxt-link
        v-for="(item, index) of data.items"
        :key="index"
        :to="getPath(item)"
        class="linked-model__item body-m-regular"
        :class="{
          'linked-model__item_select': item.selected,
          'linked-model__item_full_match': !item.full_match,
          'linked-model__item_disabled': !item.is_active,
        }"
      >
        {{ item?.name }}
        <div
          v-if="!item.full_match"
          :class="{ 'linked-model__item_line_full_match': !item.full_match }"
        ></div>
      </nuxt-link>
    </component>
  </div>
</template>
<script setup lang="ts">
import type { LinkedModel, LinkedModelItem } from '~/interfaces/api';
import HorizontalScroll from '~/components/ui/horizontal-scroll/HorizontalScroll.vue';
import { useMediaQueryStore } from '~/stores/mediaQuery';

const props = defineProps({
  data: {
    type: Object as () => LinkedModel,
    required: true,
  },
  addFilterQuery: {
    type: String,
    default: '',
  },
});
const mediaStore = useMediaQueryStore();
const isLessLg = computed(
  () =>
    mediaStore.isLessEs || mediaStore.isEs || mediaStore.isSm || mediaStore.isMd
);
const getPath = (item: LinkedModelItem): string => {
  if (!item || !item.full_match) return '';
  if (!props.addFilterQuery) return item.full_match ? `/${item.slug}/` : '';
  return `/${item.slug}/?${props.addFilterQuery}`;
};
const selectedValue = computed(() => {
  return props.data.items.reduce((value, attr: LinkedModelItem) => {
    return attr.full_match && attr.selected ? attr?.name : value;
  }, '');
});
</script>

<style scoped lang="scss">
.linked-model-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
  @include lg-block {
    margin-bottom: 20px;
  }

  &.last {
    margin-bottom: 0;
  }
}

.linked-model__title {
  font-style: normal;
  color: $achromatic-disabled;

  .linked-model__value {
    color: $achromatic-black;
  }
}

.linked-model-items__wrapper {
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 100%;
  @include lg-block {
    flex-wrap: wrap;
  }
}

.linked-model__item {
  position: relative;
  padding: 6px 12px;
  height: 32px;
  background: $white;
  border: solid 1px $achromatic-dots;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  color: $achromatic-black;
  text-decoration: none;
  justify-content: center;
  align-items: baseline;
  display: flex;
  line-height: 20px;
  white-space: nowrap;
  margin-top: 8px;
  margin-right: 8px;
  border-radius: 8px;

  &:hover {
    background: $light-blue;
  }

  &_disabled {
    border: 1px dashed $achromatic-dots;
  }
}

.linked-model__item_select {
  border: 1px solid $main-cta;
  padding: 5px 12px;

  &:hover {
    background: $light-blue;
  }
}

.linked-model__item_full_match {
  //color: $button-disabled;
  cursor: default;
  opacity: 0.4;
  background: $achromatic-card-bg;
  border: none;

  &:hover {
    background: $achromatic-card-bg;
  }
}

.linked-model__item_line_full_match {
  width: 45px;
  position: absolute;
  height: 1px;
  top: 50%;
  background-color: $button-disabled;
  transform: rotate(335deg);
}
</style>
